import {
	signupRequest,
} from './requests.js';

const parseUseCases = (str) => {
	return str.split(';').filter(p => (p !== ''));
}

export const sendSignup = (fields) => {
	const signupBody = {
		organizationName: fields.get('Company'),
		password: fields.get('Password'),
		firstName: fields.get('FirstName'),
		lastName: fields.get('LastName'),
		accountType: 'enterprise',
		token: fields.get('token'),
		deployment: fields.get('slfSignUpRegion'),
	};

	if (fields.get('oauth')) {
		signupBody.oauth = 'oauth';
		delete signupBody.password;
	}

	if (fields.get('useCases')) {
		signupBody.trialType = 'test';
		signupBody.isSampleDataEnabled = true;
		signupBody.useCases = parseUseCases(fields.get('useCases'));
	}

	return signupRequest(signupBody);
}
